/* tslint:disable */
/**
 */
export class TicketCounters {
    id?: number;
    company_id?: number;
    name?: string;
    position?: string;
    account_name?: string;
    account_no?: string;
    bank_id?: string;
    bank_display_name?: string;
    created_at?: string;
    updated_at?: string;
    page?: number;
    limit?: number;
}
